export const STATUS_META = {
  CONFIRMED: { label: "Onaylandı", color: "#71717a" },
  PLANNED: { label: "Planlandı", color: "#a1a1aa" },
  DRIVER_UNDERWAY: { label: "Yola Çıktı", color: "#f59e0b" },
  DRIVER_ARRIVED: { label: "Noktada", color: "#3b82f6" },
  JOURNEY_IN_PROGRESS: { label: "Yolculukta", color: "#8b5cf6" },
  COMPLETED: { label: "Tamamlandı", color: "#10b981" },
  CANCELLED_FREE: { label: "İptal", color: "#ef4444" },
  CANCELLED_WITH_COSTS: { label: "İptal (Ücretli)", color: "#ef4444" },
  PENDING: { label: "Beklemede", color: "#71717a" },
};

export const statusMeta = (s) => STATUS_META[s] || { label: s || "—", color: "#71717a" };

export const STEP_META = [
  { key: "underway", label: "İşi Başlat", desc: "Sürücü yola çıktı" },
  { key: "arrived", label: "Alım Noktasına Ulaştım", desc: "Noktada bekleniyor" },
  { key: "in_progress", label: "Misafiri Aldım", desc: "Yolculuk başladı" },
  { key: "completed", label: "Misafiri Bıraktım", desc: "Yolculuk tamamlandı" },
];

export function fmtTime(iso, tz) {
  if (!iso) return "—";
  try {
    const d = new Date(iso.length <= 19 && !iso.endsWith("Z") ? iso : iso);
    return new Intl.DateTimeFormat("tr-TR", {
      day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
    }).format(d);
  } catch {
    return iso;
  }
}

export function fmtLocal(localTime) {
  if (!localTime) return "—";
  const [date, time] = localTime.split("T");
  if (!time) return localTime;
  const [y, m, d] = date.split("-");
  const months = ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"];
  return `${d} ${months[parseInt(m, 10) - 1]} · ${time.slice(0, 5)}`;
}
